// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__yIqdG","headerElements":"styles_headerElements__RFYzu"};